<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p>This book is dedicated to the memory of my dear husband, John, who so tragically passed away as I was putting the finishing touches to the manuscript. During all our time together, he offered constant support and encouragement to me in my writing, and in so many other ways. I feel he stands at my shoulder still.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?36087af6